import React from 'react'
import SocialMediaLinks from '/src/components/SocialMediaLinks'

const Footer = ({}) => (
  <footer className="footer">
    <div className="content has-text-centered">
      <div className='columns is-centered'>
        <SocialMediaLinks />
      </div>
    </div>
  </footer>
)

export default Footer
